/**
 * 公共方法
 * */

// 导入公共模块
export * from '@src/_common/utils/mUtils'


export function getUrlParams() {
  let url = window.location.href.split('?')[1];
  let obj = {};
  if (!url) {
    return obj
  }
  if (url.indexOf('&') > -1) {
    url = url.split('&');
    for (let i = 0; i < url.length; i++) {
      let arr = url[i].split("=");
      obj[arr[0]] = arr[1];
    }
  } else {
    url = url.split("=");
    obj[url[0]] = url[1];
  }
  return obj
}

let timeout = null;
export function debounce(fn, wait) {
  if (timeout !== null) clearTimeout(timeout);
  timeout = setTimeout(fn, wait);
}
